import { ApiProperty } from "@nestjs/swagger";

export class RmcolumnByIdDto{
    @ApiProperty()
    columnsId:number;
}